export const PREDICTION_FILE = 'Prediction file';
export const SOURCE_FILE = 'Source file';
export const SUBMIT = 'submit';

export const fieldPrediction = {
  name: PREDICTION_FILE,
  value: '',
  isRequired: true,
  accept: ['text/csv'],
  acceptTypeText: 'csv',
  description: ' Prediction file generated as defined in the problem.',
  error: {
    allowedFiles: 'Only .csv files are allowed',
  },
};
export const fieldSource = {
  name: SOURCE_FILE,
  value: '',
  isRequired: false,
  accept: [
    'application/zip',
    'application/octet-stream',
    'application/x-zip-compressed',
    'multipart/x-zip',
    'application/vnd.rar',
    'application/x-rar-compressed',
    'application/octet-stream',
    'application/x-tar',
    'application/x-ipynb+json',
    'application/x-python-code',
    'text/x-python',
    '.r',
  ],
  acceptTypeText: '.zip, .rar, .tar, .ipynb, .py & .r',
  description: 'Source code used to train & test the model.',
  error: {
    allowedFiles: ' Only .zip, .rar, .tar, .ipynb, .py & .r files are allowed',
  },
};

export const SOLUTION_DESCRIPTION_TEXT = 'Upload Attachments';
export const DATASET_DESCRIPTION =
  ' This dataset can be used to train and test models in your solution.';
export const submissionMeta =
  'This problem has a limit on the number of times you can submit.';

export const REVISION_ERROR = 'REVISION_ERROR';
export const REVISION_CREATED = 'revision_created';
export const RESULT_SECTION = {
  SUBMISSION_HISTORY: 'Submission History',
  TEST_RESULT: 'Test Result',
  EVALUATE_SUBMIT: 'EVALUATE & SUBMIT',
  NEXT_QUESTION: 'Next question',
};

export const BROWSE_TO_UPLOAD = 'Browse to upload file';
export const FILE_TYPE_SUPPORT_TEXT = 'file type supported - only';
export const RELOAD_CODE = 'Load revision';
export const LATEST_SUBMISSION = 'Latest Submission';

export const SOLUTION_FILE = {
  PREDICTION: 'Solution prediction file',
  SOURCE: 'Solution source file',
};
